import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import * as UserAction from '../../../../Store/Actions/User';
import { UserWithBalance } from '../../../../Store';
import Header from '../../../../Components/Header';
import { FooterMenu } from '../../../../Components/FooterMenu';
import Loader from '../../../../Components/Loader';

export const AgentUserRedirect = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const userName = useParams().username;
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setNotFound(false);
    if (userName) {
      UserAction.getUsers(userName).then((u: UserWithBalance[]) => {
        if (u && u.length > 0) {
          navigate(`/Agent/Users/${u[0].user.id}`);
        } else {
          UserAction.getUsers(userName, null, true).then((u2: UserWithBalance[]) => {
            if (u2 && u2.length > 0) {
              navigate(`/Agent/Users/${u2[0].user.id}`);
            } else {
              setNotFound(true);
            }
          }).catch(() => {
            setNotFound(true);
          });
        }
      }).catch(() => {
        setNotFound(true);
      });
    } else {
      setNotFound(true);
    }
  }, [userName]);

  return (
    <div className='agent_layout'>
      <Header name={t('transactions.member')} agentMenu={true} backToHome={true} />
      <div className='content' style={{ flex: '1 1 auto', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        { !notFound && <Loader />}
        { notFound && <p>User not found</p>}
      </div>
      <FooterMenu />
    </div>
  );
};
